import { CSS_UNITS, DIALOG_SIZE, HTML, URL } from "@libs/interfaces/layouts"
import { Button, Intent } from "@blueprintjs/core"
import { useEffect, useState } from "react"
import ScalableDialog from "../ScalableDialog"
import useVKApi from "@/modules/pe-basic-module/hooks/useVKApi" 
import VkVideoPlayList from "./VkVideoPlayList.tsx"
import PlayList from "./PlayList" 
import PlayListItem from "./PlayListItem" 
import { useSyncState } from "src/modules/pe-basic-module/hooks/useSyncState"
import { useIfaceStore, IIfaceProps } from "src/settings/zustand"
import { getDementionData } from "src/libs/utilities"

/* Protopia Ecosystem component */
export interface IVKVideoButtonProps {
    src: URL 
    btnWidth?:  number | string
    btnHeight?: number | string
    padding?:   number | string
    intent?:    Intent | string
    minimal?:   boolean
    fill?:      boolean
    image?:     URL
    label:      HTML
    description?:HTML
    isModal?:   boolean
    isAutoMode?: boolean
    isPlayButton?: boolean
    descriptionAfter?: boolean
    isPlayed?: boolean
    isPlayerOpen?: boolean
    onEnded?: () => void
}
const VKVideoButton = (props: IVKVideoButtonProps): JSX.Element => {
    const wData = getDementionData( props.btnWidth || 640 )
    return props.isAutoMode
        ?
        ( wData.units === CSS_UNITS.PX && ( wData.value || 200 ) > 320 )  || wData.units !== CSS_UNITS.PX
            ?
            props.isModal
                ?
                <ModalButton {...props} />   
                :
                <InlineButton {...props} />
            :
            <ModalButton {...props} />
        :
        props.isModal
            ?
            <ModalButton {...props} />
            :
            <InlineButton {...props} />
}
export default VKVideoButton

export const ModalButton = (props: IVKVideoButtonProps): JSX.Element => {
    const [isOpen, setIsOpen] = useState<boolean>(false)
    const [player, setPlayer] = useState<any>()
    const width  = !isNumeric( props.btnWidth ) ? props.btnWidth?.toString()  || "640px" : Number(props.btnWidth)  + "px"
    const height = !isNumeric(props.btnHeight)  ? props.btnHeight?.toString() || "320px" : Number(props.btnHeight) + "px"
    const iframe = (/<iframe/).test(props.src)
        ?
        doAutoplay( props.src, "&autoplay=1&js_api=1 id=" + getId(props.src)) 
        : 
        props.src
      
    const initPlayer = (player: any) => {
        setPlayer( player )
        player?.play()
    }   
    const onPaused = () => {
        //setIsOpen(false)
    } 
    const onEnded = () => {
        if(props.onEnded) props.onEnded()
    }
    return <div style={{padding: props.padding, width, height}} className="vk-video-button-container"> 
        <VKButton {...props} width={width} height={height} setIsOpen={setIsOpen} isReady={ true } />
        <ScalableDialog 
            dialogSize={DIALOG_SIZE.NORMAL}
            isOpen={isOpen}
            mayFullScreen
            hideClose={ false }
            onClose={ () => setIsOpen( false ) } 
        > 
            <div className=" h-100 min-height-350 d-flex flex-column"> 
                <VKVideoPlayer 
                    value={ iframe } 
                    width={"100%"} 
                    height={ props.btnHeight || 360 }  
                    player={player}
                    onPaused={ onPaused } 
                    onEnded={ onEnded } 
                    initPlayer={initPlayer}
                    isPlayed={props.isPlayed}
                />
            </div>
        </ScalableDialog>
    </div>
}

export const InlineButton = (props: IVKVideoButtonProps): JSX.Element => {
    const [isOpen, setIsOpen] = useState<boolean>( !!props.isPlayerOpen )
    const [isReady, setIsReady] = useState<boolean>( true )
    const player = useSyncState<any>(null)
    
    useEffect(() => {
        setIsOpen( !!props.isPlayerOpen )
        setIsReady(true)
    }, [props.isPlayerOpen])

    const width: string  = !isNumeric( props.btnWidth ) 
        ? 
        props.btnWidth?.toString()  || "640px" 
        : 
        Number(props.btnWidth)  + "px"
    const height: string = !isNumeric(props.btnHeight)  ? props.btnHeight?.toString() || "320px" : Number(props.btnHeight) + "px"
    const iframe: string = (/<iframe/).test(props.src)
        ?
        doAutoplay( props.src, `&autoplay=${ props.isPlayed ? 1 : 0 }&js_api=1 id=${ getId( props.src ) }`) 
        : 
        props.src  
        
    const initPlayer = (_player: any) => {
        player.set( _player )         
        setIsReady(false)
        if(props.isPlayed) {
            //onPlay()
        }
    }
    const onPlay = ( isOpen: boolean = true ) => { 
        setIsOpen(true)
        setIsReady(true)
        if(!!player.get()) {
            player.get().play()
        } 
    }
    const onPaused = () => {
        setIsOpen(false)
    } 
    const onEnded = () => {
        if(props.onEnded) props.onEnded()
    }

    return <div  
        className="inline-btn-container"
        style={{
            // width : props.btnWidth,
            // minWidth: props.btnWidth,
            height: props.btnHeight,
            // overflow: "hidden",
            // margin: props.padding, 
            backgroundColor:"#00000033", 
            position: "relative",
        }}
    > 
        <div className={`position-absolute-none top left w-100 h-100 ${!isOpen ? "d-none" : ""}`} >
            <VKVideoPlayer 
                value={ iframe } 
                width={ width } 
                height={ props.btnHeight || 360 }  
                player={player.get()}
                onPaused={ onPaused } 
                onEnded={ onEnded } 
                initPlayer={initPlayer}
                isPlayed={props.isPlayed} 
            />

        </div>
        <div className={`position-absolute-none top left w-100 h-100 ${isOpen ? "d-none" : ""}`} >
            <VKButton 
                {...props}  
                width={ width } 
                height={ parseInt( props.btnHeight?.toString() || "480px" ) } 
                setIsOpen={ onPlay } 
                isPlayButton={ props.isPlayButton } 
                isReady={ true }
            />
        </div> 
        {
            props.description && props.descriptionAfter &&
                <div className="vk-after-player-description smaller text-justify" dangerouslySetInnerHTML={{ __html: props.description || "" }} /> 
        }
    </div>
}

interface IVKButtonProps extends IVKVideoButtonProps {
    width: string  | number
    height: string | number
    setIsOpen: (isOpen: boolean) => void
    isReady: boolean
}

const VKButton = ({setIsOpen, width, height, ...props}: IVKButtonProps): JSX.Element => {
    return <div 
        className="vk-video-btn-container"
        style={{ 
            minWidth:  width || "100%", 
            maxWidth:  width || "100%", 
            width: 600,
            position: "relative",
            display: "flex", 
            flexDirection: "column" 
        }}
    >
        <Button 
            intent={props.intent as Intent  || Intent.NONE} 
            variant={props.minimal ? "minimal" : "solid"}
            fill={props.fill}
            onClick={ () => setIsOpen(true) }
            className="p-0 btn-stretch vk-thumb-button" 
            style={{ 
                width: width || "100%", 
                //height: height || 20 
            }}
        >
            <div 
                className="pe-video-btn"
                style={{
                    width, 
                    //height,
                    backgroundImage: `url(${props.image})`,
                }}
            >   
                <div 
                    className="anti-muar position-absolute-none top left"
                    style={{ 
                        width, 
                        //height, 
                    }}
                />                 
                <div 
                    className="pe-video-btn position-absolute-none top left bg-transparent "
                    style={{ 
                        width, 
                        //height, 
                    }}
                >
                    {
                        props.isPlayButton &&
                            <div className="play-btn">
                                <i className={`fas ${ !props.isReady ? "fa-spin fa-sync-alt fa-2x" : "fa-play"} w-100 text-center`} /> 
                            </div>
                    }
                    <span className="label mt-3 untouchble text-center bg-dark px-2 py-1" dangerouslySetInnerHTML={{ __html: props.label || "" }} /> 
                    {
                        props.description && !props.descriptionAfter &&
                            <span className="description mt-3 untouchble text-center" dangerouslySetInnerHTML={{ __html: props.description || "" }} /> 
                    }
                </div>
            </div>
        </Button> 
    </div>
}

export interface IVKVideoPlayerProps {
    width:number | string
    height: number | string
    value: string
    player?: any
    isPlayed?: boolean
    onPaused? : () => void
    onEnded? : () => void
    initPlayer?: (player: any) => void

}
export const VKVideoPlayer = (props: IVKVideoPlayerProps) : JSX.Element => {
    const isDisabled: boolean   = useVKApi () 
    const players: any[]        = useIfaceStore((state: IIfaceProps) => state.players)
    const videoWidth            = props.width  ? props.width  : 390
    const videoHeight           = props.height ? props.height : 260
    // useEffect(() => {        
    //     console.log( props.isPlayed )        
    //     if(!!props.isPlayed) { 
    //         console.log("VK play", props.player) 
    //         props.player?.play()
    //     }
    // // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, [ props.isPlayed ])
    const initPlayer = () => {
        try {
            var iframe = document.getElementById(getId( props.value ))
            if( iframe ){ 
                if(!window.VK?.VideoPlayer) {
                    console.error("No VK.VideoPlayer loaded. ", getId( props.value ) )
                    return
                }
                const player = window.VK.VideoPlayer( iframe )
                    //console.log( "initPlayer",  player )
                
                player.on("inited", (state: any) => {
                    if(!!props.initPlayer) {
                        props.initPlayer(player)
                    } 
                    if(!!props.isPlayed) { 
                        // console.log("VK play init") 
                        player.play()
                    }
                })
                player.on("paused", (state: any) => {
                    //console.log( "paused",  state ) 
                    if(!!props.onPaused) props.onPaused()
                })
                player.on("started", (state: any) => {                
                    //console.log(state)
                    players
                        .filter(p => p !== player)
                        .forEach(p => p.pause())
                    
                })
                player.on("ended" , (state: any) => {
                    //console.log("player ended")
                    if(!!props.onEnded) props.onEnded()
                }) 
                useIfaceStore.setState({players: [...players, player]})
            }
            else {
                console.error("No load container for ", getId( props.value ) )
            } 
        }
        catch(e: any) {
            console.error( e )
        }
    }
    useEffect(() => {
        if(!isDisabled) {  
            initPlayer() 
        }
        else {

        }
        return () => {
            // console.log( players )
            useIfaceStore.setState({
                players: players.filter(pl => pl !== props.player)
            })
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isDisabled, props.value])

    const __html = props.value
        .replace(/width="\d*"/, "width='"+ videoWidth + "'")
        .replace(/height="\d*"/, "height='"+videoHeight+"'")
        .replace(/width='\d*'/, "width='"+ videoWidth + "'")
        .replace(/height='\d*'/, "height='"+videoHeight+"'")
        .replace(/width=d*/, "width='"+ videoWidth + "'")
        .replace(/height=d*/, "height='"+videoHeight+"'") 
        .replace("iframe", `iframe style="display: flex; flex-grow:100;" `)
        
    const value = <div className="w-100 h-100 position-relative">
        <div className='w-100 h-100 flex-grow-100 d-flex flex-column ' dangerouslySetInnerHTML={{ __html }} />
        
    </div>
    return value
}

VKVideoPlayer.stopAll = () => {
    const players: any[] = useIfaceStore.getState().players
    players.forEach(player => {
        try { 
            console.log(player) 
            player.pause()
        }
        catch(error: any) {
            console.log(error)  
        }
    })

}


function isNumeric(params:string | number | undefined) : boolean { 
    return !!params ? params.toString() === parseInt( params.toString() ).toString() : false
}

function getSrcData( iframe: string ) :RegExpExecArray | null {
    const match = (/<iframe[^>]+src=([^\s]+)[\s]/).exec(iframe)
    return match
}

function doAutoplay(iframe: string, replace: string) : string  { 
    const match: RegExpExecArray | null = getSrcData( iframe )
    return match 
        ? 
        iframe.replace( match[1],  match[1] + replace)
        : 
        iframe
     
}
function getId( iframe: string ): string {
    const match: RegExpExecArray | null = (/<iframe[^>]+&id=([^&hash]+)[&hash]/).exec(iframe)
    return  (match ? match[1] : Math.random().toString()).toString()
}

export {
    VkVideoPlayList,
    PlayList,
    PlayListItem
}